<template>
 <div>
  <!-- tab下详情页 -->
    <components v-if="tabType" :is="tabType"></components>
    <carDetail :tabName="activeName"  v-else />
 </div>
</template>
<script>
import carDetail from './carDetail.vue'
import { tabDetail } from './config'
import outInDetails from '../components/outInDetails.vue' // 出入库详情
// 个人租赁订单详情
import personalOrderDetail from '@/pages/orders/personalOrder/detail/index.vue'

export default {
  components: {
    carDetail,
    outInDetails,
    personalOrderDetail,
  },
  data() {
    return {
      tabType: '', // 用来处理展示子订单详情页
      activeName: '', // 用来处理返回到对应tab
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to && to.query && to.query.tabType) {
          this.tabType = tabDetail[to.query.tabType]
          this.activeName = ''
        } else if (from && from.query && from.query.tabType) {
          this.tabType = ''
          this.activeName = from.query.tabType || ''
        } else {
          this.activeName = ''
          this.tabType = ''
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
